<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <div style="display: flex">
                        <div style="flex: 1"></div>
                        <div>
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                        </div>
                        <div>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizzazione a Schede" @click="onClickVisualizzazione('card')" class="mr-1 no-text">
                                <i class="fas fa-grip-horizontal"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizzazione a Card" @click="onClickVisualizzazione('list')" class="mr-1 no-text">
                                <i class="fas fa-list"></i>
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="sa-test" style="height: 100%" v-if="view === 'card'">
                <div class="sa-card-list">
                    <b-row>
                        <b-col v-for="item of items" :key="item.id" class="sa-card-list-col" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <div :class="{ 'sa-card-list-container': true, 'sa-card-list-container-disabled': isDisableCard(item) }">
                                <div v-if="item.regime === 'AMBULATORIALE'" class="sa-card-list-container-header">Regime Ambulatoriale</div>
                                <div v-else-if="item.regime === 'DOMICILIARE'" class="sa-card-list-container-header">Regime Domiciliare</div>
                                <div v-else class="sa-card-list-container-header">{{ item.denominazionePresidio }} - {{ item.nomeStanza }} - {{ item.nomeLetto }}</div>
                                <div class="sa-card-list-container-body">
                                    <div>
                                        <img v-if="item.sesso === 'M'" src="@/assets/images/ico_m.png" />
                                        <img v-else src="@/assets/images/ico_f.png" />
                                    </div>
                                    <div style="flex: 1; padding-left: 5px">
                                        <span class="sa-card-list-container-body-row"
                                            ><b>{{ item.cognome + " " + item.nome }}</b></span
                                        >
                                        <span class="sa-card-list-container-body-row">{{ item.numero }} - {{ formatDate(item.dataAccettazione) }}</span>
                                        <span class="sa-card-list-container-body-row">{{ item.identificativo }}</span>
                                        <span class="sa-card-list-container-body-row">Data Nascita: {{ formatDate(item.dataNascita) }}</span>
                                        <span class="sa-card-list-container-body-row">{{ calcoloEta(item.dataNascita) }}</span>
                                    </div>
                                </div>
                                <div class="sa-card-list-container-footer text-right">
                                    <b-button v-b-tooltip.hover size="sm" variant="outline-success outline-secondary-noborder pull-right" title="Cartella Paziente" @click="onOpenSchedaPaziente(item)" class="mr-1 no-text">
                                        <b-icon icon="book" variant="outline-sucess"></b-icon>
                                    </b-button>
                                    <b-button size="sm" v-if="item.regime === 'RESIDENZIALE'" v-b-tooltip.hover title="Cambio Posto Letto" variant="outline-success outline-secondary-noborder pull-right" @click="onClickRicovera(item)" class="mr-1 no-text">
                                        <font-awesome-icon icon="bed" />
                                    </b-button>
                                    <template v-if="item.statoAttuale === 'RICOVERATO'">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-purple outline-secondary-noborder pull-right" title="Registra Uscita" @click="onClickPresenzaUscita(item)" class="mr-1">
                                            <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                        </b-button>

                                        <!-- DA DECOMMENTARE SE SI LAVORA SULLE USCITE -->
                                        <!-- <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Gestisci Uscite" @click="onClickConfigurazionePresenzaUscite(row.item)">
                                    <font-awesome-icon :icon="['fas', 'cog']" />
                                </b-button> -->
                                    </template>
                                    <b-button v-if="item.statoAttuale !== 'RICOVERATO' && (item.regime === 'RESIDENZIALE' || item.regime === 'SEMIRESIDENZIALE')" v-b-tooltip.hover size="sm" variant="outline-danger outline-secondary-noborder pull-right" title="Registra Entrata" @click="onClickPresenzaEntrata(item)" class="sa-icon-rotate">
                                        <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                    </b-button>
                                    <print-component :linkPrintReport="linkPrintReport(item)" :typeButton="'small'" :documentRepository="false"></print-component>
                                    <!-- <b-button v-b-tooltip.hover title="Stampa" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onClickStampa(item)">
                    <b-icon icon="printer"></b-icon>
                  </b-button> -->
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div v-if="view === 'list'" style="height: 100%" class="sa-test">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table" :tbody-tr-class="getRowClass">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(numero)="{ item }">
                            <span>{{ item.numero }}</span> <br />
                            <span>{{ formatDate(item.dataRicovero) }}</span>
                        </template>
                        <template v-slot:cell(nominativo)="{ item }">
                            <span>{{ item.cognome }} {{ item.nome }}</span>
                            <span style="display: block">({{ item.identificativo }})</span>
                        </template>
                        <template v-slot:cell(eta)="{ item }">
                            <span>{{ calcoloEta(item.dataNascita) }}</span>
                        </template>
                        <template v-slot:cell(presidio)="{ item }">
                            <span>{{ item.denominazionePresidio }}</span>
                        </template>
                        <template v-slot:cell(settings)="{ item }">
                            <span>{{ item.settingDescrizione }}</span>
                        </template>
                        <!--   
                    <template v-slot:cell(email)="{ item }">
                        <span>{{ item.email }}</span>
                    </template> -->
                        <!--   <template v-slot:cell(camera)="{ item }"> -->
                        <template v-slot:cell(camera)="{ item }">
                            <template v-if="item.regime === 'RESIDENZIALE'">
                                <span class="sa-table-span-label-primary">Piano: {{ item.nomePiano }}</span>
                                <span class="sa-table-span-label-primary">Stanza: {{ item.nomeStanza }}</span>
                                <span class="sa-table-span-label-primary">Letto: {{ item.nomeLetto }}</span>
                            </template>
                        </template>
                        <!--    </template> -->
                        <template v-slot:cell(actions)="row">
                            <!-- <b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Ospite" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="book" variant="outline-sucess"></b-icon>
							</b-button>
						</b-container> -->

                            <b-container class="bv-example-row">
                                <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Paziente" @click="onOpenSchedaPaziente(row.item)" class="mr-1 no-text">
                                    <b-icon icon="book" variant="outline-sucess"></b-icon>
                                </b-button>
                                <b-button v-if="isButtonVisible && row.item.regime === 'RESIDENZIALE'" size="sm" v-b-tooltip.hover title="Cambio Posto Letto" variant="outline-success" @click="onClickRicovera(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="bed" />
                                </b-button>
                                <!-- <b-button v-if="row.item.statoAttuale === 'RICOVERATO'" v-b-tooltip.hover size="sm" variant="outline-success" title="Registra Uscita" @click="onClickConfigurazionePresenzaUscite(row.item)">
                                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                            </b-button> -->
                                <template v-if="row.item.statoAttuale === 'RICOVERATO' && (row.item.regime === 'RESIDENZIALE' || row.item.regime === 'SEMIRESIDENZIALE')">
                                    <b-button v-b-tooltip.hover size="sm" variant="outline-purple" title="Registra Uscita" @click="onClickPresenzaUscita(row.item)" class="mr-1">
                                        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                    </b-button>

                                    <!-- DA DECOMMENTARE SE SI LAVORA SULLE USCITE -->
                                    <!-- <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Gestisci Uscite" @click="onClickConfigurazionePresenzaUscite(row.item)">
                                    <font-awesome-icon :icon="['fas', 'cog']" />
                                </b-button> -->
                                </template>
                                <b-button v-if="row.item.statoAttuale !== 'RICOVERATO' && (row.item.regime === 'RESIDENZIALE' || row.item.regime === 'SEMIRESIDENZIALE')" v-b-tooltip.hover size="sm" variant="outline-danger" title="Registra Entrata" @click="onClickPresenzaEntrata(row.item)" class="sa-icon-rotate">
                                    <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                </b-button>
                                <print-component v-if="isButtonVisible && enablePrintButton" :linkPrintReport="linkPrintReport(row.item)" :typeButton="'small'" :documentRepository="false"></print-component>
                                <!-- <b-button v-b-tooltip.hover title="Stampa" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onClickStampa(row.item)">
                  <b-icon icon="printer"></b-icon>
                </b-button> -->
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="sa-list-component-invisible">
            <rsa-registrazione-uscite-entrate-modal-edit-component ref="cmpRsaRegistrazioneUsciteEntrateModalEdit" @onSave="onSavePresenza" @onClose="onClosePresenza" />
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <modal-loading ref="cmpModalLoading"></modal-loading>
        <modal-error ref="cmpModalError"></modal-error>
        <rsa-assegna-posto-letto-modal-edit-component ref="cmpAccettazionePostiLettoModalEdit" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
    </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaRegistrazioneUsciteEntrateModalEditComponent from "./RsaRegistrazioneUsciteEntrateModalEditComponent.vue";
import RsaAssegnaPostoLettoModalEditComponent from "../../rsaaccettazione/components/RsaAssegnaPostoLettoModalEditComponent.vue";
import ModalLoading from "../../../../template/components/modal/components/ModalLoading.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
export default {
    name: "RsaGestioneOspitiListComponent",
    props: { pathResource: { type: String, default: "/rsaospiti" }, regime: { type: String, default: "RESIDENZIALE" } },
    mixins: [UtilityMixin],
    components: { ModalLoading, PrintComponent, RsaRegistrazioneUsciteEntrateModalEditComponent, RsaAssegnaPostoLettoModalEditComponent, ModalError },
    data() {
        return {
            view: "list",
            rows: 0,
            perPage: 50,
            currentPage: 1,
            //pathResource: ,
            pathResourceStampa: "/rsaprintdata/folder",
            filtroGestioneOspiti: {},
            stampaReport: "",
            items: [],
            listKey: 0,
            enablePrintButton: true,
            isButtonVisible: true,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                },
                {
                    label: "Numero Cartella",
                    key: "numero",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                    // sortable: true,
                },
                {
                    label: "Età",
                    key: "eta",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                },
                {
                    label: "Presidio",
                    key: "presidio",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                },
                {
                    label: this.getLabelTraduora("nurity.accettazione.setting"),
                    key: "settings",
                    setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
                },
                {
                    label: "Camera",
                    key: "camera",
                    setting: "RESIDENZIALE",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE" },
            ],
        };
    },
    computed: {
        visibleFields() {
            return this.fields.filter((field) => field.setting.includes(this.regime));
        },
    },
    mounted() {
        let me = this;
        me.enablePrintButton = this.appConfig.enablePrintButton;
        let sessionStorage = window.sessionStorage;
        let user = JSON.parse(sessionStorage.getItem("user"));
        let localStorage = window.localStorage;
        let localData = localStorage.getItem("viewData");
        if (!localData) {
            localData = {};
            localData[user.username] = { view: "list" };
            localStorage.setItem("viewData", JSON.stringify(localData));
        } else {
            localData = JSON.parse(localData);
        }
        this.view = localData[user.username].view;
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(filtro, isButtonVisible) {
            let me = this;
            me.isButtonVisible = isButtonVisible;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneOspiti"]) {
                sessionStorage.removeItem("filtroGestioneOspiti");
            }
            me.filtroGestioneOspiti = filtro;
            me.loadData(me.filtroGestioneOspiti);
        },
        setLocalData(value) {
            let sessionStorage = window.sessionStorage;
            let user = JSON.parse(sessionStorage.getItem("user"));
            let localStorage = window.localStorage;
            let localData = {};
            localData[user.username] = { view: value };
            localStorage.setItem("viewData", JSON.stringify(localData));
        },
        loadData(filtro = null) {
            let me = this;
            if (filtro === null) {
                let sessionStorage = window.sessionStorage;
                filtro = JSON.parse(sessionStorage.getItem("filtroGestioneOspiti"));
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            filtro.page = me.currentPage;
            filtro.forPage = me.perPage;
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
            /*    } else {
                this.$emit("afterLoadData");
                this.$bvModal.msgBoxOk("Inserire Presidio", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                });
            } */
        },

        onClickStampa(item) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
            axios
                .get(link, { params: { idAccettazione: item.id } })
                .then((response) => {
                    me.stampaReport = "data:application/pdf;base64," + response.data.data;

                    me.$refs.cmpModalLoading.close();
                })
                .catch((error) => {
                    let me = this;
                    me.$refs.cmpModalError.show(error + "#");
                    me.$refs.cmpModalLoading.close();
                });
        },

        onEdit(item) {
            let me = this;
            me.$router.push("/rsagestioneospiti/schedaospite/view/" + item.id);
        },
        onOpenSchedaPaziente(item) {
            let me = this;
            me.$router.push("/rsapaziente/view/" + item.id);
        },
        /* onClickPresenzaEntrata(item) {
            let me = this;
            console.log("onClickPresenzaEntrata", item);
            me.$refs.cmpRsaSchedaOspiteUsciteList.onClickAggiorna(item.id, item.statoAttuale);
        }, */

        onClickConfigurazionePresenzaUscite(item) {
            let me = this;
            me.$router.push("/rsapaziente/uscite" + "?idAccettazione=" + item.id);

            // console.log("onClickConfigurazionePresenzaUscite", item);
            // me.registraPresenza(item.id, 'USCITA');
        },
        onClickPresenzaUscita(item) {
            let me = this;
            me.$refs.cmpRsaRegistrazioneUsciteEntrateModalEdit.show(item, "USCITA");
            // console.log("ITEM: ", item);
        },
        onClickPresenzaEntrata(item) {
            let me = this;
            me.$refs.cmpRsaRegistrazioneUsciteEntrateModalEdit.show(item, "ENTRATA");
            // console.log("ITEM: ", item);
        },
        onSavePresenza() {
            let me = this;
            me.loadData();
        },
        onClosePresenza() {},
        resetList() {
            let me = this;
            me.items = [];
        },
        onClickRicovera(item) {
            let me = this;
            me.$refs.cmpAccettazionePostiLettoModalEdit.show(item);
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },

        linkPrintReport(item) {
            return this.pathResourceStampa + "?idAccettazione=" + item.id;
        },
        getRowClass(item) {
            let returnValue = "";
            if (item.statoAttuale === "ASSENTE") {
                returnValue = "row-color-disabled";
            }
            return returnValue;
        },
        isDisableCard(item) {
            return item.statoAttuale === "ASSENTE";
        },
        onClickVisualizzazione(tipo) {
            this.setLocalData(tipo);
            this.view = tipo;
        },
    },
};
</script>
<style>
.riga-assente {
    background-color: #e8eaeb59 !important;
}

.row-color-disabled {
    background-color: #b3c3d1;
}

.sa-card-list-container-disabled {
    border-left: 4px solid #b3c3d1 !important;
}
</style>
